import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { startDiagnostics } from "./diag.js";

startDiagnostics();

const root = document.getElementById("root");
if (!root) throw new Error("No #root element — index.html and this entry disagree.");

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
